export const makeReducer = (name, initialState, handlers) => {
    return (state = initialState, action) => {
        try {
            const { type, payload } = action;

            return handlers[type] ? handlers[type](state, payload) : state;
        } catch (e) {
            console.error('Error while executing reducer %s - %s', name, action && action.type ? action.type : 'unknown action');
            console.error(e);
            return state;
        }
    };
};
